import React from "react";
export default function () {
    return (
        <svg width="200" height="200" viewBox="0 0 200 200">
            <path d="M19.7,93.1h0l5-12.5,8.1-20.2c-8.1,6.6-12,4.9-12,4.9,1.8-2.8,1.8-6.5-.6-7.5a7.1,7.1,0,0,0-6.5.8,4.2,4.2,0,0,0-.8,5.8c1.8,2.5,4.5,2.6,7.1,2.7s9.6-2,9.6-2L21.5,83l-1.1,2.5h0L17,93.1" />
        </svg>
    );
}
